<template>
    <div class="list row">
        <h2>Ovlašćenja</h2>
        <div class="actions d-flex flex-row-reverse">
            <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
            <button type="button" class="btn btn-success bi bi-plus" @click="addData" />
        </div>
        <data-table url="authorized" :columns="columns" :templates="templates" :headings="headers" :actions="actions"
            ref="datatable" @yes="deleteData" name="Authorized">
        </data-table>
    </div>
</template>

<script>
import AuthorizedDataService from "../../services/authorized.service";
import DataTable from "../widgets/DataTable.vue";
import AuthorizedForm from "./AuthorizedForm.vue";

export default {
    name: "authorized",
    components: {
        DataTable,
    },
    data() {
        return {
            columns: ["id", "full_name", "jmbg", "address", "lk_num", "edit"],
            headers: {
                id: "Id",
                full_name: "Ime i prezime",
                jmbg: "JMBG",
                address: "Adresa",
                lk_num: "Broj LK",
                edit: "",
            },
            templates: {},
            actions: {
                edit: { commp: AuthorizedForm },
                delete: {
                    deleteData: this.deleteData,
                    color: "danger",
                    icon: "bi-trash",
                },
            },
            title: "",
        };
    },
    methods: {
        refreshData() {
            this.$refs.datatable.onRefresh();
        },
        addData() {
            this.$store.commit("app/showModal", {
                modal: AuthorizedForm,
                params: { data: {}, title: "Dodaj novo ovlašćenje" },
            });
        },
        deleteData(data) {
            AuthorizedDataService.delete(data.id)
                .then((response) => {
                    this.$store.commit("app/showAlert", {
                        type: "success",
                        message: response.data.message,
                    });
                    this.$store.commit("app/hideModal");
                })
                .catch((e) => {
                    console.log(e);
                    this.$store.commit("app/showAlert", {
                        type: "danger",
                        message: e,
                    });
                });
        },
    },
};
</script>

<style scoped>
.list {
    text-align: left;
    margin: auto;
}
</style>
